import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HistoryMenu from "./HistoryMenu";
import ProfileModal from "./ProfileModal";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";

const { FiLogOut, FiPower, FiUser, FiChevronDown } = FiIcons;

const Header = ({
  history,
  onSelectHistory,
  onDelete,
  isLocked,
  onReset,
  onLogout,
  getAudioChunksForSavedMeeting,
}) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  const feedbackUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSdQ7pLXmdYPIUGbNm3xGxit4EdAkvWdVySFdfJbGioJG3AlLA/viewform?usp=pp_url&entry.1008255467=xxx";
  const originUrl = typeof window !== "undefined" ? window.location.origin : "";
  const fullFeedbackUrl = feedbackUrl.replace("xxx", originUrl);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <motion.header
        className="bg-white shadow-sm border-b border-gray-200 p-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="container mx-auto flex justify-between items-center">
          <div
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => {
              if (onReset) onReset();
            }}
          >
            <img
              src="/images/yy_default.jpg"
              alt="App Logo"
              className="w-16 h-16 rounded-lg flex-shrink-0"
            />
            <div className="min-w-0">
              <h1 className="text-xl font-bold text-green-700 group-hover:text-green-800 transition-colors truncate">
                <span className="tracking-wide">ยั่งยืน 'ย่อ'</span>
                <span className="text-base font-normal ml-2">[v. 1.99]</span>
              </h1>
              <div className="flex items-center gap-x-2">
                <p className="text-sm text-gray-600 hidden md:block truncate">
                  ผู้ช่วย AI ที่พร้อม "ย่อ" ทุกสิ่งให้คุณ
                </p>
                {/* <a
                  href={fullFeedbackUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="text-xs sm:text-sm text-green-600 hover:text-green-800 hover:underline transition-colors flex-shrink-0"
                >
                  (ส่ง Feedback)
                </a> */}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {!isLocked && (
              <HistoryMenu
                history={history}
                onSelectHistory={onSelectHistory}
                onDelete={onDelete}
                getAudioChunksForSavedMeeting={getAudioChunksForSavedMeeting}
              />
            )}
            {onLogout && (
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsProfileOpen(!isProfileOpen)}
                  className="p-2 text-slate-500 hover:text-green-600 hover:bg-slate-100 rounded-full flex items-center gap-1"
                >
                  <SafeIcon icon={FiUser} className="w-5 h-5" />
                  <SafeIcon icon={FiChevronDown} className="w-4 h-4" />
                </button>
                <AnimatePresence>
                  {isProfileOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20"
                    >
                      <button
                        onClick={() => {
                          setIsModalOpen(true);
                          setIsProfileOpen(false);
                        }}
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                      >
                        <SafeIcon icon={FiUser} /> Profile
                      </button>
                      <button
                        onClick={onLogout}
                        className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 flex items-center gap-2"
                      >
                        <SafeIcon icon={FiPower} /> Logout
                      </button>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
          </div>
        </div>
      </motion.header>
      <ProfileModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Header;
